import { STICKY_BOTTOM_SHADOW_STUCK_OFFSET } from './useStickyBottomShadow.constants'

export function isStickyBottomElementStuck(element) {
  return (
    element.parentElement.getBoundingClientRect().bottom -
      element.getBoundingClientRect().bottom >
    STICKY_BOTTOM_SHADOW_STUCK_OFFSET
  )
}
